import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { useL10n } from '@uplift/hooks';
import { Alert, Button } from '@uplift/ui-v2';
import { betterhelpSsoInit } from '@uplift/api';


const useStyles = makeStyles()((theme) => ({
  container: {
    width: '100%',
    maxWidth: '510px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  button: {
    maxWidth: '432px',
  },
  error: {
    marginTop: theme.spacing(1),
    maxWidth: '432px',
    width: '100%',
  },
}));


type BetterhelpSsoButtonProps = {
  variant?: 'contained' | 'outlined';
};

export const BetterhelpSsoButton: React.VFC<BetterhelpSsoButtonProps> = ({ variant = 'outlined' }) => {
  const { classes } = useStyles();
  const l10n = useL10n();
  const [ loading, setLoading ] = useState(false);
  const [ error, setError ] = useState(false);

  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        setLoading(false);
      }
    };

    window.addEventListener('pageshow', handlePageShow);

    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);

  const handleClick = async () => {
    setLoading(true);
    setError(false);
    try {
      const { data } = await betterhelpSsoInit();

      if (data.binding === 'redirect') {
        window.location.assign(data.redirectUrl);
      } else {
        const form = document.createElement('form');

        form.method = 'POST';
        form.action = data.postUrl;

        const samlInput = document.createElement('input');

        samlInput.type = 'hidden';
        samlInput.name = 'SAMLRequest';
        samlInput.value = data.samlRequest;
        form.appendChild(samlInput);

        if (data.relayState) {
          const relayInput = document.createElement('input');

          relayInput.type = 'hidden';
          relayInput.name = 'RelayState';
          relayInput.value = data.relayState;
          form.appendChild(relayInput);
        }

        document.body.appendChild(form);
        form.submit();
      }
    } catch {
      setError(true);
      setLoading(false);
    }
  };

  return (
    <Box className={classes.container}>
      <Button
        fullWidth
        variant={variant}
        color="primary"
        size="large"
        loading={loading}
        onClick={handleClick}
        className={classes.button}
      >
        {l10n.auth.continueWithBetterhelp}
      </Button>
      {error && (
        <Box className={classes.error}>
          <Alert severity="error" title={l10n.auth.errors.unknown.title} showIcon={false}>
            {l10n.auth.errors.unknown.details}
          </Alert>
        </Box>
      )}
    </Box>
  );
};
